import {
  Autocomplete,
  Button,
  Container,
  Grid,
  IconButton,
  MenuItem,
  Radio,
  RadioGroup,
  Select,
  Stack,
  tableCellClasses,
  TextField,
  Tooltip,
  Typography,
  FormControlLabel,
  InputAdornment
} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import { useForm, useWatch, useFieldArray, Controller } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import * as yup from 'yup';
import { styled } from '@mui/material/styles';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import { Box } from '@mui/system';
import { useCallback, useEffect, useState } from 'react';
import { AiFillCloseCircle, AiFillEdit, AiOutlineMinus } from 'react-icons/ai';
import { useDispatch } from 'react-redux';
import { MdModeEdit, MdOutlineAdd, MdOutlineUpdate } from 'react-icons/md';
import { useLocation, useNavigate } from 'react-router-dom';
import { format } from 'date-fns';
import { ExcelRenderer } from 'react-excel-renderer';
import { BiCloudDownload, BiCloudUpload } from 'react-icons/bi';
import BrudCrumbs from '../../components/BreadCrumbs';
import Page from '../../components/Page';
import PageTitle from '../../components/PageHeading';
import useLoginSelector from '../../store/Slice/Login/LoginSelector';
import useGlobalSelector from '../../store/Slice/Global/GlobalSelector';
import {
  getBankDropdownData,
  getLoanTypeData,
  saveApiData
} from '../../store/Slice/Global/GlobalSlice';
import { StyledIconButton, StyledTableRow } from '../../utils/StyleTable';
import useOnboardingSelector from '../../store/Slice/Onboarding/OnboardingSelector';
import { getOnboardingShowData } from '../../store/Slice/Onboarding/OnboardingSlice';
import { OnboardingApi, UserApi } from '../../utils/Apis';
import CustomInput from '../../components/CustomInput';
import CustomSelect from '../../components/CustomSelect';
import { setApiError } from '../../store/Slice/Error/ErrorSlice';
import RevenueService from '../services/RevenueService';
import { getIncentiveList } from '../../store/Slice/User/UserSlice';
import useUserSelector from '../../store/Slice/User/UserSelector';
import { savefileApiData } from '../../store/Slice/Payout/PayoutSlice';

const validationSchema = yup.object().shape({
  partnerCommission: yup
    .array()
    .of(
      yup
        .object()
        .shape({
          bankId: yup.string().required('Please select bank name'),
          loanTypeId: yup.string().required('Please select loan type'),
          companyCommition: yup
            .number()
            .typeError('Type company commission %')
            .required('Type company commission %')
            .min(0, 'Commission cannot be negative')
            .max(100, 'Commission cannot exceed 100%'),
          partnerCommition: yup
            .number()
            .typeError('Type partner share %')
            .required('Type partner share %')
            .min(0, 'Partner share cannot be negative')
            .max(100, 'Partner share cannot exceed 100%')
        })
        .test(
          'total-not-greater-than-100',
          'Sum of Company Commission & Partner Share should not be greater than 100%',
          function (item) {
            const total = Number(item.companyCommition || 0) + Number(item.partnerCommition || 0);
            if (total > 100) {
              return this.createError({
                path: `${this.path}.partnerCommition`, // attach error to partnerCommition
                message: 'Sum of Company Commission & Partner Share should not be greater than 100%'
              });
            }
            return true;
          }
        )
    )
    .min(1, 'At least one partner commission entry is required')
});

const StyledTableCell = styled(TableCell)(({ theme }) => ({
  [`&.${tableCellClasses.head}`]: {
    fontSize: 12,
    padding: '6px',
    height: '42.5px',
    fontWeight: 500,
    textTransform: 'uppercase',
    color: '#0d4689'
  },
  [`&.${tableCellClasses.body}`]: {
    fontSize: 11,
    padding: '4px 6px',
    height: '42.5px'
  }
}));

function SetIncentiveForEmployeePartner() {
  const [editcomm, setEditcomm] = useState('');
  const [autosugval, setAutosugval] = useState({
    loanTypeId: '',
    companyCommition: '',
    partnerCommition: ''
  });
  const [downloadTemplateMsg, setDownloadTemplateMsg] = useState('');

  const dispatch = useDispatch();
  const location = useLocation();
  const { rowId } = location?.state || {};
  // console.log('rowIdrowIdrowId', rowId);
  const { LoginData } = useLoginSelector();
  const { OnboardingShowCommision } = useOnboardingSelector();
  const { BankDrop, LoanTypeDrop } = useGlobalSelector();
  const [selection, setSelection] = useState('manually');
  const [file, setFile] = useState(null);
  const [selectedFileName, setSelectedFileName] = useState('');
  const [openDownloadTemplateDialog, setOpenDownloadTemplateDialog] = useState(false);
  const [uploadfile, setUploadfile] = useState(null);
  const [openLoader, setOpenLoader] = useState(false);
  const [open, setOpen] = useState(false);
  const [targetSlbsArray, setTargetSlbsArray] = useState([
    {
      minAmount: null,
      maxAmount: null,
      incentivePercent: null
    }
  ]);

  const [disburseSlbsArray, setdisburseSlbsArray] = useState([
    {
      bankName: null,
      loanType: null,
      incentivePercent: null
    }
  ]);

  const getLoanMasterApi = useCallback(() => {
    // console.log('getLoanMasterApi called, LoginData:', LoginData);

    if (!LoginData?.companyId || !LoginData?.userId) {
      console.log('LoginData not available yet');
      return;
    }

    // console.log('Calling getLoanTypeData API with:', {
    //   companyId: LoginData.companyId,
    //   userId: LoginData.userId
    // });

    const obj = {
      companyId: LoginData.companyId,
      userId: LoginData.userId
    };
    dispatch(getLoanTypeData(obj));
  }, [LoginData, dispatch]);

  useEffect(() => {
    // console.log('useEffect running, calling getLoanMasterApi');
    getLoanMasterApi();
  }, [getLoanMasterApi]);

  const navigate = useNavigate();

  // console.log('LoanTypeData222:', LoanTypeDrop);
  // console.log('BankDrop222:', BankDrop);

  const newBankDrop = [{ label: 'All', value: 0 }, ...(BankDrop || [])] || [];
  const newMasterLoanTypeDrop = [{ label: 'All', value: 0 }, ...(LoanTypeDrop || [])] || [];
  const {
    control,
    handleSubmit,
    watch,
    resetField,
    formState: { errors }
  } = useForm({
    defaultValues: {
      incentiveType: '',
      incentiveDuration: '',
      targetSlabs: [{ minAmount: '', maxAmount: '', incentivePercent: '' }],
      disbursementConfigs: [{ bankName: '', loanType: '', incentivePercent: '' }]
    }
  });

  const {
    fields: targetFields,
    append: appendTarget,
    remove: removeTarget
  } = useFieldArray({
    control,
    name: 'targetSlabs'
  });

  const {
    fields: disburseFields,
    append: appendDisburse,
    remove: removeDisburse
  } = useFieldArray({
    control,
    name: 'disbursementConfigs'
  });

  const { DownloadIncentiveTemplate } = RevenueService;

  const incentiveTypeValue = useWatch({
    control,
    name: 'incentiveType'
  });

  const compnayPercen = useWatch({
    control,
    name: 'companyPercentage'
  });

  const DurationValue = useWatch({
    control,
    name: 'incentiveDuration'
  });

  useEffect(() => {
    console.log('Selected Incentive Type:', incentiveTypeValue);
  }, [incentiveTypeValue]);

  const onSubmit = async (formData) => {
    let payload;

    if (formData.incentiveType === 'TARGET_BASED') {
      payload = {
        employeeId: rowId,
        userId: LoginData?.userId,
        incentiveType: 'TARGET_BASED',
        duration: formData.incentiveDuration,
        companyPercentage: formData.companyPercentage,
        targetSlabs: formData.targetSlabs.map((item) => ({
          ...item,
          incentivePercent: Number(item.incentivePercent)
        }))
      };
    }

    if (formData.incentiveType === 'DISBURSEMENT_BASED') {
      payload = {
        employeeId: rowId,
        userId: LoginData?.userId,
        incentiveType: 'DISBURSEMENT_BASED',
        duration: formData.incentiveDuration,
        companyPercentage: formData.companyPercentage,
        disbursementConfigs: formData.disbursementConfigs.map((item) => ({
          ...item,
          incentivePercent: Number(item.incentivePercent)
        }))
      };
    }

    const result = await dispatch(saveApiData(UserApi.createIncentive, payload));

    if (result?.status === 'success') {
      dispatch(setApiError('Successfully added new Record'));
      getIncentiveData();
    }
  };

  const getBankDropApi = useCallback(() => {
    if (!LoginData) return;
    const data = { companyId: LoginData?.companyId, userId: LoginData?.userId };
    dispatch(getBankDropdownData(data));
  }, [dispatch, LoginData]);

  const getOnboardingShowDataApi = useCallback(() => {
    if (!LoginData && !rowId) return;
    const data = {
      companyId: LoginData?.companyId,
      partnerId: rowId?.partnerId || rowId,
      sortOrder: 'asc'
    };
    dispatch(getOnboardingShowData(data));
  }, [rowId, LoginData]);

  useEffect(() => {
    getBankDropApi();
  }, [getBankDropApi]);

  useEffect(() => {
    getOnboardingShowDataApi();
  }, [getOnboardingShowDataApi]);

  const handleRadioChange = (event) => {
    setSelection(event.target.value);
    setFile(null); // reset file if radio changes
  };

  const handleRenderFile = (fileObj) => {
    ExcelRenderer(fileObj, (err, resp) => {
      if (err) {
        console.error('Error reading excel file', err);
        setOpenLoader(false);
        return;
      }
      // If you need to process `resp.rows`, do it here…
      setOpenLoader(false);
    });
  };

  // SIMPLE, SAFE FILE HANDLER
  const handleFileChange = (e) => {
    const file = e.target.files?.[0];
    if (!file) return;

    const fileName = file.name;
    const ext = fileName.slice(fileName.lastIndexOf('.') + 1).toLowerCase();

    setSelectedFileName(fileName);
    setUploadfile(file);

    if (ext === 'xlsx' || ext === 'xls' || ext === 'csv') {
      setOpenLoader(true);
      handleRenderFile(file);
    } else {
      // reset file if wrong type
      setUploadfile(null);
      setSelectedFileName('');
      setOpen(true);
      dispatch(setApiError('Please add only xlsx/csv/xls file only'));
    }
  };

  const handleDownloadTemplate = async (type) => {
    // console.log('Selected:', type);
    const path = {
      incentiveType: incentiveTypeValue
    };

    try {
      const response = await DownloadIncentiveTemplate(path, path, LoginData?.jwt);

      const contentType = response.headers.get('content-type');
      // console.log('content-type =>', contentType);

      const blob = await response.blob();
      // console.log('response222', blob);
      let fileName = `${incentiveTypeValue}-IncentiveDownload_${format(
        new Date(),
        'dd-MM-yyyy_HH-mm-ss'
      )}`;
      let mimeType = contentType;

      fileName += '.xlsx';
      mimeType = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet';

      const url = window.URL.createObjectURL(new Blob([blob], { type: mimeType }));

      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', fileName);
      document.body.appendChild(link);
      link.click();
      link.remove();
      window.URL.revokeObjectURL(url);
    } catch (error) {
      console.error('Export error:', error);
    }
  };

  const { IncentiveListData } = useUserSelector();

  const getIncentiveData = useCallback(() => {
    dispatch(getIncentiveList(rowId));
  }, [dispatch, rowId]);

  useEffect(() => {
    getIncentiveData();
  }, [getIncentiveData]);

  const uploadSubmit = async (e) => {
    // e.preventDefault();
    if (!DurationValue) {
      setOpen(true);
      dispatch(setApiError('Please Select Duration Dropdown'));
      return;
    }
    if (!uploadfile) {
      setOpen(true);
      dispatch(setApiError('Please upload MIS file'));
      return;
    }

    const formUploadData = new FormData();
    formUploadData.append('employeeId', rowId);
    formUploadData.append('incentiveType', incentiveTypeValue);
    formUploadData.append('duration', DurationValue);
    formUploadData.append('createdBy', 146);
    formUploadData.append('file', uploadfile);
    formUploadData.append('companyPercent', compnayPercen);

    const result = await dispatch(
      savefileApiData(UserApi?.uploadIncentive, formUploadData, LoginData?.jwt)
    );
    if (result?.data?.status === 'success') {
      dispatch(setApiError(result?.data?.message || 'Uploaded Successfully'));
      getIncentiveData();
    }
    // console.log('sss upload result', result);
  };

  function handleIncentiveType() {
    setUploadfile(null);
    setSelectedFileName('');
    setFile(null);
    resetField('incentiveDuration');
  }

  function handleClose() {
    setSelectedFileName(() => null);
  }

  return (
    <Page title="Kpros by Kalolytic Solutions || On Boarding">
      <Container maxWidth="xl" mb={3}>
        <Box pt={3} pb={3}>
          <Stack
            direction="row"
            alignItems="center"
            justifyContent="space-between"
            className="pageHeading"
          >
            <PageTitle info="Set Incentive" />
            <Box>
              <BrudCrumbs />
            </Box>
          </Stack>

          <Typography variant="body1" className="headingLineUp headingLineUpOut">
            Incentive Type
          </Typography>
          <Box className="viewLeadCard cardTopMinusMargin" mb={3}>
            <Grid container spacing={3}>
              <Grid item xs={4}>
                <CustomSelect
                  name="incentiveType"
                  label="Incentive Type"
                  control={control}
                  errors={errors}
                  onChange={() => handleIncentiveType()}
                  isRequired
                  options={[
                    { label: 'Target Based', value: 'TARGET_BASED' },
                    { label: 'Disbursement Based', value: 'DISBURSEMENT_BASED' }
                  ]}
                />
              </Grid>
            </Grid>
          </Box>
          {incentiveTypeValue === 'TARGET_BASED' && (
            <>
              <Typography variant="body1" className="headingLineUp headingLineUpOut">
                Target Based Loan Requirement
              </Typography>

              <Box className="viewLeadCard cardTopMinusMargin" mb={3}>
                <Box>
                  {/* Radio Buttons */}
                  <RadioGroup
                    row
                    value={selection}
                    onChange={handleRadioChange}
                    style={{ marginBottom: '20px' }}
                  >
                    <FormControlLabel value="manually" control={<Radio />} label="Manually" />
                    <FormControlLabel value="upload" control={<Radio />} label="Upload" />
                  </RadioGroup>

                  <Grid container spacing={3} mb={3}>
                    <Grid item xs={4}>
                      <CustomSelect
                        name="incentiveDuration"
                        label="Incentive Duration "
                        control={control}
                        errors={errors}
                        isRequired
                        options={[
                          { label: 'Monthly', value: 'MONTHLY' },
                          { label: 'Quarterly', value: 'QUARTERLY' },
                          { label: 'Yearly', value: 'YEARLY' }
                        ]}
                      />
                    </Grid>
                    <Grid item xs={4}>
                      <CustomInput
                        name="companyPercentage"
                        label="Company Percentage %"
                        control={control}
                        errors={errors}
                        type="number"
                        isRequired
                      />
                    </Grid>
                  </Grid>

                  {/* Upload Button – shown only if YES */}
                  {selection === 'manually' && (
                    <form onSubmit={handleSubmit(onSubmit)}>
                      {targetFields.map((item, index) => (
                        <Grid container spacing={3} key={item.id} alignItems="end" mb={2}>
                          <Grid item xs={4}>
                            <CustomInput
                              name={`targetSlabs.${index}.minAmount`}
                              label="Min Amount"
                              control={control}
                              errors={errors?.targetSlabs?.[index]}
                              type="number"
                              isRequired
                            />
                          </Grid>

                          <Grid item xs={3}>
                            <CustomInput
                              name={`targetSlabs.${index}.maxAmount`}
                              label="Max Amount"
                              control={control}
                              errors={errors?.targetSlabs?.[index]}
                              type="number"
                              isRequired
                            />
                          </Grid>

                          <Grid item xs={3}>
                            {/* <CustomInput
                              name={`targetSlabs.${index}.incentivePercent`}
                              label="Incentive %"
                              control={control}
                              errors={errors?.targetSlabs?.[index]}
                              type="number"
                              isRequired
                            /> */}
                            <Controller
                              name={`targetSlabs.${index}.incentivePercent`}
                              control={control}
                              defaultValue=""
                              render={({ field }) => (
                                <Box>
                                  {/* Top label – NO animation */}
                                  <Typography variant="h6" className="formLabel">
                                    Incentive % <span style={{ color: 'red' }}>*</span>
                                  </Typography>

                                  <TextField
                                    {...field}
                                    fullWidth
                                    placeholder="Enter Incentive %"
                                    inputProps={{
                                      maxLength: 2,
                                      inputMode: 'numeric',
                                      pattern: '[0-9]*',
                                      className: 'textInput' // same class as other inputs
                                    }}
                                    onChange={(e) => {
                                      const value = e.target.value.replace(/[^0-9]/g, '');

                                      // HARD STOP after 2 digits
                                      if (value.length > 2) return;

                                      field.onChange(value);
                                    }}
                                    InputProps={{
                                      endAdornment: (
                                        <InputAdornment position="end">%</InputAdornment>
                                      )
                                    }}
                                  />
                                </Box>
                              )}
                            />
                          </Grid>

                          {/* ADD */}
                          <Grid item xs="auto" display="flex">
                            <IconButton
                              onClick={() =>
                                appendTarget({
                                  minAmount: '',
                                  maxAmount: '',
                                  incentivePercent: ''
                                })
                              }
                            >
                              <MdOutlineAdd />
                            </IconButton>

                            {/* REMOVE */}
                            {targetFields.length > 1 && (
                              <Grid item xs="auto">
                                <IconButton onClick={() => removeTarget(index)}>
                                  <AiOutlineMinus />
                                </IconButton>
                              </Grid>
                            )}
                          </Grid>
                        </Grid>
                      ))}

                      <Box className="" mb={3} textAlign="right">
                        <Button variant="contained" type="submit" className="mainBtn">
                          Submit
                        </Button>
                      </Box>
                    </form>
                  )}
                  {selection === 'upload' && (
                    <Grid container alignItems="center" spacing={3}>
                      <Grid item xs mb={3}>
                        <Box variant="Container" className="uploadBox uploadBoxSec">
                          <input
                            accept=".xlsx, .xls, .csv"
                            className="fileInput"
                            id="contained-button-file"
                            multiple
                            type="file"
                            onChange={handleFileChange}
                          />

                          <label htmlFor="contained-button-file">
                            <Box>
                              {selectedFileName ? (
                                <Typography variant="body2">
                                  {`Selected file name : ${selectedFileName}`}
                                  <IconButton
                                    onClick={(e) => {
                                      e.preventDefault();
                                      e.stopPropagation();
                                      handleClose();
                                    }}
                                    size="small"
                                    sx={{
                                      color: '#03A9F4', // icon color (light blue)
                                      backgroundColor: '#E1F5FE', // very light blue bg
                                      ml: 1,
                                      '&:hover': {
                                        backgroundColor: '#B3E5FC' // darker on hover
                                      }
                                    }}
                                  >
                                    <CloseIcon />
                                  </IconButton>
                                </Typography>
                              ) : (
                                <>
                                  <BiCloudUpload className="upladIcon" />
                                  <Typography variant="h5">Upload</Typography>
                                  <Typography variant="body2">
                                    Supported file types: .xls, .xlsx, .csv
                                  </Typography>
                                </>
                              )}
                            </Box>
                          </label>
                        </Box>
                      </Grid>

                      <Grid xs="auto" item mb={3} sx={{ flexGrow: '1' }}>
                        <Button
                          className="mainBtn downloadBtn downloadBtnSec otherBtn"
                          variant="contained"
                          onClick={handleDownloadTemplate}
                        >
                          <BiCloudDownload className="downloadIcon" />
                          <Typography variant="subtitle1">Download Template</Typography>
                        </Button>
                      </Grid>
                      <Grid item xs={12}>
                        <Box className="" mb={3} textAlign="right">
                          <Button
                            onClick={() => uploadSubmit()}
                            variant="contained"
                            type="submit"
                            className="mainBtn"
                          >
                            Submit
                          </Button>
                        </Box>
                      </Grid>
                    </Grid>
                  )}
                </Box>
              </Box>
            </>
          )}
          {incentiveTypeValue === 'DISBURSEMENT_BASED' && (
            <>
              <Typography variant="body1" className="headingLineUp headingLineUpOut">
                Disbursement Based Loan Requirement
              </Typography>

              <Box className="viewLeadCard cardTopMinusMargin" mb={3}>
                <Box>
                  {/* Radio Buttons */}
                  <RadioGroup
                    row
                    value={selection}
                    onChange={handleRadioChange}
                    style={{ marginBottom: '20px' }}
                  >
                    <FormControlLabel value="manually" control={<Radio />} label="Manually" />
                    <FormControlLabel value="upload" control={<Radio />} label="Upload" />
                  </RadioGroup>

                  <Grid container spacing={3} mb={3}>
                    <Grid item xs={4}>
                      <CustomSelect
                        name="incentiveDuration"
                        label="Incentive Duration "
                        control={control}
                        errors={errors}
                        isRequired
                        options={[
                          { label: 'Monthly', value: 'MONTHLY' },
                          { label: 'Quarterly', value: 'QUARTERLY' },
                          { label: 'Yearly', value: 'YEARLY' }
                        ]}
                      />
                    </Grid>
                    <Grid item xs={3}>
                      <CustomInput
                        name="companyPercentage"
                        label="Company Percentage %"
                        control={control}
                        errors={errors}
                        type="number"
                        isRequired
                      />
                    </Grid>
                  </Grid>

                  {/* Upload Button – shown only if YES */}
                  {selection === 'manually' && (
                    <form onSubmit={handleSubmit(onSubmit)}>
                      {disburseFields.map((item, index) => (
                        <Grid container spacing={3} key={item.id} alignItems="end" mb={2}>
                          <Grid item xs={4}>
                            <CustomSelect
                              name={`disbursementConfigs.${index}.bankName`}
                              label="Bank"
                              control={control}
                              options={newBankDrop}
                              errors={errors?.disbursementConfigs?.[index]}
                              isRequired
                            />
                          </Grid>

                          <Grid item xs={3}>
                            <CustomSelect
                              name={`disbursementConfigs.${index}.loanType`}
                              label="Loan Type"
                              control={control}
                              options={newMasterLoanTypeDrop}
                              errors={errors?.disbursementConfigs?.[index]}
                              isRequired
                            />
                          </Grid>

                          <Grid item xs={3}>
                            {/* <CustomInput
                              name={`disbursementConfigs.${index}.incentivePercent`}
                              label="Incentive %"
                              control={control}
                              errors={errors?.disbursementConfigs?.[index]}
                              type="number"
                              isRequired
                            /> */}
                            <Controller
                              name={`targetSlabs.${index}.incentivePercent`}
                              control={control}
                              defaultValue=""
                              render={({ field }) => (
                                <Box>
                                  {/* Top label – NO animation */}
                                  <Typography variant="h6" className="formLabel">
                                    Incentive % <span style={{ color: 'red' }}>*</span>
                                  </Typography>

                                  <TextField
                                    {...field}
                                    fullWidth
                                    placeholder="Enter Incentive %"
                                    inputProps={{
                                      maxLength: 2,
                                      inputMode: 'numeric',
                                      pattern: '[0-9]*',
                                      className: 'textInput' // same class as other inputs
                                    }}
                                    onChange={(e) => {
                                      const value = e.target.value.replace(/[^0-9]/g, '');

                                      // HARD STOP after 2 digits
                                      if (value.length > 2) return;

                                      field.onChange(value);
                                    }}
                                    InputProps={{
                                      endAdornment: (
                                        <InputAdornment position="end">%</InputAdornment>
                                      )
                                    }}
                                  />
                                </Box>
                              )}
                            />
                          </Grid>

                          {/* ADD */}
                          <Grid item xs="auto" display="flex">
                            <IconButton
                              onClick={() =>
                                appendDisburse({
                                  bankName: '',
                                  loanType: '',
                                  incentivePercent: ''
                                })
                              }
                            >
                              <MdOutlineAdd />
                            </IconButton>
                            {/* REMOVE */}
                            {disburseFields.length > 1 && (
                              <Grid item xs="auto">
                                <IconButton onClick={() => removeDisburse(index)}>
                                  <AiOutlineMinus />
                                </IconButton>
                              </Grid>
                            )}
                          </Grid>
                        </Grid>
                      ))}

                      <Box className="" mb={3} textAlign="right">
                        <Button variant="contained" type="submit" className="mainBtn">
                          Submit
                        </Button>
                      </Box>
                    </form>
                  )}
                  {selection === 'upload' && (
                    <Grid container alignItems="center" spacing={3}>
                      <Grid item xs mb={3}>
                        <Box variant="Container" className="uploadBox uploadBoxSec">
                          <input
                            accept=".xlsx, .xls, .csv"
                            className="fileInput"
                            id="contained-button-file"
                            multiple
                            type="file"
                            onChange={handleFileChange}
                          />

                          <label htmlFor="contained-button-file">
                            <Box>
                              {selectedFileName ? (
                                <Typography variant="body2">
                                  {`Selected file name : ${selectedFileName}`}
                                </Typography>
                              ) : (
                                <>
                                  <BiCloudUpload className="upladIcon" />
                                  <Typography variant="h5">Upload</Typography>
                                  <Typography variant="body2">
                                    Supported file types: .xls, .xlsx, .csv
                                  </Typography>
                                </>
                              )}
                            </Box>
                          </label>
                        </Box>
                      </Grid>

                      <Grid xs="auto" item mb={3} sx={{ flexGrow: '1' }}>
                        <Button
                          className="mainBtn downloadBtn downloadBtnSec otherBtn"
                          variant="contained"
                          onClick={handleDownloadTemplate}
                        >
                          <BiCloudDownload className="downloadIcon" />
                          <Typography variant="subtitle1">Download Template</Typography>
                        </Button>
                      </Grid>
                      <Grid item xs={12}>
                        <Box className="" mb={3} textAlign="right">
                          <Button
                            onClick={() => uploadSubmit()}
                            variant="contained"
                            type="submit"
                            className="mainBtn"
                          >
                            Submit
                          </Button>
                        </Box>
                      </Grid>
                    </Grid>
                  )}
                </Box>
              </Box>
            </>
          )}
        </Box>
        <Typography variant="body1" className="headingLineUp headingLineUpOut">
          Incentive List
        </Typography>
        <Box className="viewLeadCard cardTopMinusMargin viewCardPadding" mb={5}>
          <TableContainer sx={{ minWidth: 800, overflow: 'auto', background: 'white' }}>
            <Table>
              <TableHead>
                <TableRow>
                  <StyledTableCell style={{ width: '230px' }} align="">
                    Duration
                  </StyledTableCell>
                  <StyledTableCell style={{ width: '230px' }} align="">
                    companyPercentage
                  </StyledTableCell>
                  <StyledTableCell style={{ width: '230px' }} align="">
                    incentiveType
                  </StyledTableCell>
                  <StyledTableCell style={{ width: '120px' }} align="">
                    incentivePercent
                  </StyledTableCell>
                  <StyledTableCell style={{ width: '230px' }} align="">
                    minAmount
                  </StyledTableCell>
                  <StyledTableCell style={{ width: '180px' }} align="">
                    maxAmount
                  </StyledTableCell>
                  <StyledTableCell style={{ width: '120px' }} align="">
                    bankName
                  </StyledTableCell>
                  <StyledTableCell style={{ width: '120px' }} align="">
                    loanType
                  </StyledTableCell>

                  <StyledTableCell style={{ width: '120px' }} align="">
                    Action
                  </StyledTableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {IncentiveListData?.map((item, index) => (
                  <StyledTableRow key={index}>
                    <StyledTableCell align="">{item?.duration}</StyledTableCell>
                    <StyledTableCell align="">{item?.companyPercentage}</StyledTableCell>
                    <StyledTableCell align="">{item?.incentiveType}</StyledTableCell>
                    <StyledTableCell align="">{item?.incentivePercent}</StyledTableCell>
                    <StyledTableCell align="">{item?.minAmount || 'N/A'}</StyledTableCell>
                    <StyledTableCell align="">{item?.maxAmount || 'N/A'}</StyledTableCell>
                    <StyledTableCell align="">{item?.bankName || 'N/A'}</StyledTableCell>
                    <StyledTableCell align="">{item?.loanType || 'N/A'}</StyledTableCell>
                    <StyledTableCell align="">
                      {' '}
                      <Tooltip title="Raise Advance Request" placement="top" arrow>
                        <StyledIconButton
                          className="squareIconButton actionButton"
                          onClick={() => {
                            navigate(`/users/edit-incentive`, { state: item });
                          }}
                        >
                          <AiFillEdit size={14} />
                        </StyledIconButton>
                      </Tooltip>
                    </StyledTableCell>
                  </StyledTableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
        </Box>
      </Container>
    </Page>
  );
}
export default SetIncentiveForEmployeePartner;
